import {makeDefaultEmpty} from '../../components/DefaultEmpty';

export const workbooksComponentsMap = {
    CustomActionPanelWorkbookActions: makeDefaultEmpty<{}>(),
} as const;
